import Vue from 'vue';

import formatAmount from './formatAmount';
import orMinus from './orMinus';
import withSuffix from './withSuffix';
import formatBBAN from './formatBBAN';
import formatPaycheckNumber from './formatPaycheckNumber';
import {yesNo, yesNoLoose} from './yesNo';
import formatDateTime from './formatDateTime';
import formatDate from './formatDate';
import formatIBAN from './formatIBAN';

Vue.filter('formatAmount', formatAmount);
Vue.filter('orMinus', orMinus);
Vue.filter('withSuffix', withSuffix);
Vue.filter('formatBBAN', formatBBAN);
Vue.filter('formatIBAN', formatIBAN);
Vue.filter('formatPaycheckNumber', formatPaycheckNumber);
Vue.filter('yesNo', yesNo);
Vue.filter('yesNoLoose', yesNoLoose);
Vue.filter('formatDateTime', formatDateTime);
Vue.filter('formatDate', formatDate);
